import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'char-counter',
    templateUrl: './character-counter.component.html',
    styleUrls: ['./character-counter.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharacterCounterComponent {
    text = input.required<string>();
    maxLength = input.required<number>();
}
